<template>
  <a
    tabindex="0"
    role="button"
    v-bind="$attrs"
    @click="handleClick"
    @keydown.enter.prevent="handleKeydown"
    @keydown.space.prevent="handleKeydown"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'FlotoAnchorLink',
  data() {
    return {}
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event) // Emit click event
    },
    handleKeydown(event) {
      // Trigger the click action on Enter or Space
      this.handleClick(event)
    },
  },
}
</script>
